/**
 * FileUploadDisplay Component
 * Reusable component to display uploaded files with download and remove options
 */

import React from 'react';
import { X, FileText } from 'react-feather';
import { getFileMetadata, viewFile } from '../utils/fileManager';

const FileUploadDisplay = ({ 
	file, 
	onRemove, 
	showDownload = true, 
	showView = true,
	showRemove = true,
	className = ''
}) => {
	if (!file) return null;
	
	const metadata = getFileMetadata(file);
	
	const handleView = (e) => {
		e.preventDefault();
		e.stopPropagation();
		viewFile(file);
	};
	
	const handleRemove = (e) => {
		e.preventDefault();
		e.stopPropagation();
		if (onRemove) {
			onRemove();
		}
	};
	
	return (
		<div className={`file-upload-display-compact ${className}`} style={styles.container}>
			<div style={styles.linkContainer}>
				<FileText size={14} style={styles.icon} />
				<button
					type="button"
					onClick={handleView}
					style={styles.link}
					title={metadata.displayName}
					className="file-link"
				>
					View File
				</button>
				
				{metadata.isUploaded && (
					<span style={styles.uploadedChip}>
						Uploaded
					</span>
				)}
			</div>
			
			{showRemove && metadata.canRemove && (
				<button
					type="button"
					onClick={handleRemove}
					style={styles.removeButton}
					title="Remove file"
					className="btn-remove-file"
				>
					<X size={14} />
				</button>
			)}
		</div>
	);
};

const styles = {
	container: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: '8px',
		padding: '6px 12px',
		backgroundColor: '#f8f9fa',
		border: '1px solid #dee2e6',
		borderRadius: '20px',
		marginTop: '8px',
		marginBottom: '4px',
	},
	linkContainer: {
		display: 'flex',
		alignItems: 'center',
		gap: '6px',
	},
	icon: {
		color: '#6c757d',
		flexShrink: 0,
	},
	link: {
		fontSize: '13px',
		fontWeight: '500',
		color: '#007bff',
		textDecoration: 'none',
		cursor: 'pointer',
		transition: 'color 0.2s ease',
		whiteSpace: 'nowrap',
		background: 'none',
		border: 'none',
		padding: '0',
		font: 'inherit',
	},
	uploadedChip: {
		display: 'inline-flex',
		alignItems: 'center',
		padding: '2px 8px',
		fontSize: '10px',
		fontWeight: '600',
		color: '#fff',
		backgroundColor: '#28a745',
		borderRadius: '10px',
		marginLeft: '4px',
		whiteSpace: 'nowrap',
	},
	removeButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '20px',
		height: '20px',
		padding: '0',
		border: 'none',
		borderRadius: '50%',
		backgroundColor: 'transparent',
		color: '#dc3545',
		cursor: 'pointer',
		transition: 'all 0.2s ease',
		marginLeft: '2px',
	},
};

// Add hover styles via CSS
const styleSheet = document.createElement('style');
styleSheet.textContent = `
	.file-link:hover {
		color: #0056b3 !important;
		text-decoration: underline !important;
	}
	
	.btn-remove-file:hover {
		background-color: #dc3545 !important;
		color: #fff !important;
		transform: scale(1.1);
	}
	
	.btn-remove-file:active {
		transform: scale(0.95);
	}
	
	.file-upload-display-compact:hover {
		border-color: #adb5bd;
		box-shadow: 0 1px 3px rgba(0,0,0,0.1);
	}
`;
document.head.appendChild(styleSheet);

export default FileUploadDisplay;
